// components/PublicLayout.tsx — header/footer chrome for the crawlable public pages (spec §4.5).
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Wordmark } from './Wordmark';
import { Mark } from './Mark';
import { ThemeToggle } from './ThemeToggle';

const NAV = [
  { to: '/about', label: 'About' },
  { to: '/security', label: 'Security' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

export function PublicLayout() {
  return (
    <div className="flex min-h-full flex-col">
      <header className="sticky top-0 z-30 border-b border-line/10 bg-surface-2/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-3.5 sm:px-8">
          <Link to="/" className="flex items-center gap-2 text-xl" aria-label="UPLOAD home">
            <Mark className="h-6 w-6 text-brand" />
            <Wordmark />
          </Link>
          <nav className="flex items-center gap-1 text-sm sm:gap-2" aria-label="Primary">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `rounded-lg px-2.5 py-1.5 font-medium transition-colors sm:px-3 ${
                    isActive ? 'text-brand' : 'text-fg-muted hover:text-fg'
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <ThemeToggle />
            <Link to="/app" className="btn">
              Get Started
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 sm:px-8">
        <Outlet />
      </main>
      <footer className="mt-16 border-t border-line/10">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-4 px-6 py-10 text-sm sm:flex-row sm:px-8">
          <div>
            <Wordmark className="text-base" />
            <p className="mt-1 text-fg-muted">Upload your working self.</p>
          </div>
          <div className="text-fg-muted">
            By{' '}
            <a className="link" href="https://deb0.com" target="_blank" rel="noreferrer">
              Debajyoti Saikia
            </a>{' '}
            · Principal Software Engineer, Microsoft
          </div>
        </div>
      </footer>
    </div>
  );
}
